// libraries/cms-template-components/src/utils/breadcrumbs.utility.ts

import type {
  BreadcrumbPath,
  MagnoliaBreadcrumbs,
  NormalizedBreadcrumbs,
} from "@jb-manage-trips/types/magnolia";

function isMagnoliaBreadcrumbs(value: unknown): value is MagnoliaBreadcrumbs {
  return typeof value === "object" && value !== null;
}

function isBreadcrumbEntry(value: unknown): value is BreadcrumbPath {
  return (
    typeof value === "object" &&
    value !== null &&
    "href" in value &&
    "label" in value &&
    typeof value.href === "string" &&
    typeof value.label === "string"
  );
}

export function normalizeBreadcrumbs(input: unknown): NormalizedBreadcrumbs {
  const breadcrumbs = isMagnoliaBreadcrumbs(input) ? input : undefined;
  const nodesField = breadcrumbs?.["@nodes"];
  const nodes = Array.isArray(nodesField)
    ? nodesField.filter((key): key is string => typeof key === "string")
    : [];
  const paths: BreadcrumbPath[] = [];

  if (breadcrumbs && nodes.length > 0) {
    for (const key of nodes) {
      const raw = breadcrumbs[key];

      if (isBreadcrumbEntry(raw)) {
        paths.push({
          href: raw.href,
          label: raw.label,
        });
      }
    }
  }

  return { nodes, paths };
}
